class MissingSynonymsError extends Error {
    constructor(m: string) {
        super(m);
    }
}

export default MissingSynonymsError;
